module.exports = __webpack_public_path__ + "img/loading-spin.c98f8aa8.svg";